import React from "react";

function ActivePlatformCreditsIcon({ fill = "#424242" }) {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6680_78055)">
        <rect
          y="-0.257812"
          width="51.3418"
          height="51.3418"
          rx="8.55696"
          fill="#F3E8FF"
        />
        <path
          d="M17 16V32C17 32.5304 17.2107 33.0391 17.5858 33.4142C17.9609 33.7893 18.4696 34 19 34H35"
          stroke="#9810FB"
          strokeWidth="1.90909"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33 22L28 27L24 23L21 26"
          stroke="#9810FB"
          strokeWidth="1.90909"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6680_78055">
          <rect
            width="51.3418"
            height="51.3418"
            fill="white"
            transform="translate(0 -0.257812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ActivePlatformCreditsIcon;
